/* eslint-disable spellcheck/spell-checker */
import { useToast } from '@kcd/design-system';

import Counter from '~/components/Counter';
import type { OAISchema } from '~/types/openapi';

type Props = {
  item: OAISchema['MarketShoppingCartItemResponseV2'];
  disabled: boolean;
  onChange?: (value: number) => void;
};
function CartCounter({
  item: {
    calcMinimumOrderQuantity,
    orderPerMultipleQuantity,
    orderableQuantity,
    quantity,
  },
  disabled,
  onChange,
}: Props) {
  const toast = useToast();

  return (
    <Counter
      initialValue={quantity}
      disabled={disabled}
      max={orderableQuantity}
      min={calcMinimumOrderQuantity}
      gap={orderPerMultipleQuantity}
      onChange={(value) => onChange?.(value)}
      onFail={toast}
    />
  );
}

export default CartCounter;
